import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CalculatorTaxComponent } from './calculator-tax.component';

const routes: Routes = [{
  path: '',
  component: CalculatorTaxComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CalculatorTaxRoutingModule { }
